<template>
  <div id="app">
    <div :class="{showLoading: showLoading}"></div>
    <div class="toastBox"
      :class="{showToast: showToast}">
      <span>{{showWord}}</span>
    </div>
    <router-view></router-view>
  </div>
</template>

<script type="text/ecmascript-6">
import api from "./api/index.js";
import socket from "@/api/socket.js"
import utils from "./utils/index.js";
import "./assets/common.css";
export default {
  name: "App",
  data() {
    return {
      showWord: "",
      showToast: false
    };
  },
  mounted() {
    // localStorage.authorId=localStorage.authorId==""?['OATXL','OAYYZX','OASY'].join(','):localStorage.authorId.split(',').concat(['OATXL','OAYYZX','OASY']).join(',');
    api.initHeader();

    this.$nextTick(() => {
      // this.resizeWindow();
    })

    let _this = this
    window.onbeforeunload = function (e) {
      if (_this.$route.name == "applyForm" || _this.$route.name == "newApplyForm") {
        e = e || window.event;
        // 兼容IE8和Firefox 4之前的版本
        if (e) {
          e.returnValue = '关闭提示';
        }
        // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
        return '关闭提示';
      } else {
        window.onbeforeunload = null
      }
    };
  },
  computed: {
    showLoading() {
      return this.$store.state.res_count;
    }
  },
  methods: {
    resizeWindow() {
      var s;
      function resize() {
        var appDom = document.getElementById("app");
        s = window.screen.width / 1920;
        document.body.style.zoom = s;
        // appDom.style.transformOrigin = '0 0';
        // appDom.style.transform = 'scale(' + s + ',' + s + ')';
        // appDom.style.width = window.innerWidth / s + 'px';
        // appDom.style.height = window.innerHeight / s + 'px';
      }
      window.onresize = function () {
        resize();
      }
      resize();
    }
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
#app {
  height: 100%;
  .showLoading {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
    background-image: url(./assets/loading.gif);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 50px 50px;
    z-index: 9999999;
  }
  .toastBox {
    position: fixed;
    z-index: 999999;
    top: -100px;
    width: 100%;
    text-align: center;
    visibility: hidden;
    transition: all 200ms;
    span {
      display: inline-block;
      padding: 10px 20px;
      background-color: rgba(0, 0, 0, 0.7);
      border-radius: 8px;
      color: #fff;
    }
    &.showToast {
      visibility: inherit;
      top: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue